var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { AccountItems } from './AccountItems';
import { ProfileDetails } from './ProfileDetails';
import { device } from '../../breakpoints';
import { colors } from '../../../../abstracts';
var AccountMenuContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  width: 292px;\n  right: 16px;\n  top: 65px;\n  background-color: ", ";\n  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  padding: 1rem;\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n\n  ", "\n\n  ", "\n\n  @media ", " {\n    position: static;\n    background-color: transparent;\n    box-shadow: none;\n    width: -webkit-fill-available;\n    padding: 10px;\n  }\n"], ["\n  position: absolute;\n  width: 292px;\n  right: 16px;\n  top: 65px;\n  background-color: ", ";\n  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.2);\n  border-radius: 8px;\n  padding: 1rem;\n  opacity: 0;\n  pointer-events: none;\n  visibility: hidden;\n\n  ", "\n\n  ", "\n\n  @media ", " {\n    position: static;\n    background-color: transparent;\n    box-shadow: none;\n    width: -webkit-fill-available;\n    padding: 10px;\n  }\n"])), colors.white, function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      transition: 0.2s ease-in-out;\n      opacity: 1;\n      pointer-events: auto;\n      visibility: visible;\n    "], ["\n      transition: 0.2s ease-in-out;\n      opacity: 1;\n      pointer-events: auto;\n      visibility: visible;\n    "])));
}, function (_a) {
    var showClaimsButton = _a.showClaimsButton;
    return showClaimsButton && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      right: 134px;\n    "], ["\n      right: 134px;\n    "])));
}, device.laptop);
export var AccountMenu = forwardRef(function (_a, fRef) {
    var groups = _a.itemGroups, email = _a.email, _b = _a.isActive, isActive = _b === void 0 ? false : _b, _c = _a.showClaimsButton, showClaimsButton = _c === void 0 ? false : _c, _d = _a.toggleDropdown, toggleDropdown = _d === void 0 ? function () { return undefined; } : _d, rest = __rest(_a, ["itemGroups", "email", "isActive", "showClaimsButton", "toggleDropdown"]);
    var clickHandler = function (onClick) {
        onClick();
        toggleDropdown(false);
    };
    return (React.createElement(AccountMenuContainer, __assign({ showClaimsButton: showClaimsButton, isActive: isActive, ref: fRef }, rest, { "aria-label": "My Account menu" }),
        email && React.createElement(ProfileDetails, { email: email }),
        React.createElement(AccountItems, { itemGroups: groups, clickHandler: clickHandler })));
});
var templateObject_1, templateObject_2, templateObject_3;
